import { Row, Space, Typography } from 'antd'
import { FC } from 'react'
import { BitazzaText } from '../../../../../components'
import { getColor } from '../../../../../util/getColor'
import Styles from './StatisticsBox.module.scss'
import { getBadges } from '../../../../../util/getBadges'
import { useNavigate } from 'react-router-dom'

interface Props {
    label1: string
    label2?: string
    badge: string
    performance: number | string
    coin?: string
    description?: string
    compared?: number | string
    onClick: () => void
    actualperformance: number | string
}
export const StatisticsBox: FC<Props> = ({
    label1,
    label2,
    badge,
    performance,
    coin,
    compared,
    onClick,
    actualperformance,
}) => {
    const { Text } = Typography
    const navigate = useNavigate()

    const getBorder: any = (badge: string) => {
        switch (badge) {
            case 'Silver':
                return {
                    borderImageSource:
                        'linear-gradient(to left, #4A5251 , #9BABA9, #4A5251)',
                }
            case 'Gold':
                return {
                    borderImageSource:
                        'linear-gradient(to left, #555133, #ECE38C, #555133)',
                }
            case 'Platinum':
                return {
                    borderImageSource:
                        'linear-gradient(to left,  #536463 ,   #69F1FF, #536463)',
                }
            default:
                return {
                    borderImageSource:
                        'linear-gradient(to left, #3F2E23 ,  #CD9572, #3F2E23)',
                }
        }
    }

    return (
        <div
            className={Styles.boxContainer}
            style={getBorder(badge)}
            onClick={onClick}
        >
            <Space direction="vertical" className={Styles.wrapper}>
                <Row justify="space-between" align="middle" wrap={false}>
                    <Space
                        direction="vertical"
                        size={0}
                        style={{ height: '54px' }}
                    >
                        <BitazzaText
                            content={label1}
                            format="t16"
                            color="#FFFFFF"
                            lineHeight={21}
                            display="block"
                        />
                        {label2 && (
                            <BitazzaText
                                display="block"
                                content={label2}
                                format="t16"
                                color="#FFFFFF"
                                lineHeight={21}
                            />
                        )}
                    </Space>
                    <img
                        src={getBadges(badge)}
                        alt="badge"
                        width={48}
                        height={48}
                        onClick={() => navigate('/badge-detail')}
                    />
                </Row>
                <div style={{ height: '42px' }}>
                    <Text
                        className={Styles.performance}
                        style={{ color: getColor(+actualperformance) }}
                    >
                        {actualperformance || actualperformance === 0
                            ? performance
                            : null}{' '}
                        {(coin && actualperformance) ||
                        actualperformance === 0 ? (
                            <BitazzaText
                                content={coin}
                                format="t14"
                                color="#86A1A1"
                                lineHeight={18}
                            />
                        ) : null}
                    </Text>
                </div>

                {actualperformance && compared ? (
                    <div className={Styles.actualperformance}>
                        <BitazzaText
                            content={compared}
                            format="t16"
                            color="#86A1A1"
                            lineHeight={12}
                            display="inline"
                        />
                    </div>
                ) : null}
            </Space>
        </div>
    )
}
